import { breakpoints, colors } from '@web-for-marketing/react-ui';

export const siteWideDemoFormStyles = {
    container: {
        position: 'relative',
        background: colors.background.white,
        width: '100%',
        borderRadius: '12px',
        padding: '2.8rem 3rem 4rem',
        boxSizing: 'border-box',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.08)',
        [`@media (max-width: ${breakpoints.md})`]: {
            padding: '2.4rem',
        },
    },
    form: { width: '100%', position: 'relative', overflow: 'hidden', paddingBottom: '1rem' },
    formGroupContainers: {
        flexDirection: 'column',
        transition: 'transform 200ms ease',
        opacity: 0,
    },
    subtitles: {
        marginBottom: '.8rem',
    },
    buttonContainer: {
        margin: '0',
        [`@media (max-width: ${breakpoints.md})`]: {
            flexDirection: 'row-reverse',
        },
    },
    geotabLogo: {
        display: 'none',
        marginBottom: '1.6rem',
        [`@media (max-width: ${breakpoints.sm}px)`]: {
            display: 'flex',
            justifyContent: 'center',
        },
    },
    progressBar: {
        marginBottom: '1rem',
        maxWidth: '70rem',
        width: '100%',
    },
    selectInput: {
        width: '100%',
        marginBottom: '2rem',
        marginTop: '0.5rem',
    },
    hidden: {
        display: 'none',
    },
    label: {
        marginBottom: '2rem',
        marginTop: '0.5rem',
    },
    previousContainer: (enableAnimation: boolean) =>
        (({
            transform: enableAnimation ? 'translateX(-10rem)' : 'none',
            position: 'absolute',
        }) as const),
    currentContainer: {
        transform: 'none !important',
        position: 'static',
        height: 'auto',
        visibility: 'visible',
    },
    nextContainer: (enableAnimation: boolean) =>
        (({
            transform: enableAnimation ? 'translateX(10rem)' : 'none',
            position: 'absolute',
        }) as const),
    visible: {
        opacity: '1 !important',
        visibility: 'visible',
    },
    invisible: {
        opacity: 0,
        visibility: 'hidden',
    },
    inlineText: {
        display: 'inline',
    },
    spacedText: {
        marginTop: '1rem',
    },
    hiddenAllyText: {
        opacity: 0,
        position: 'absolute',
        color: colors.text.inversePrimary,
        fontSize: '.1px',
        lineHeight: '.1px',
        top: 0,
        left: -999,
        height: 1,
        width: 1,
        zIndex: -999,
    },
    button: {
        width: '100%',
        [`@media (max-width: ${breakpoints.md})`]: {
            marginBottom: '1.2rem',
        },
    },
    formItem: {
        padding: '0 1rem',
        margin: '0 !important',
    },
    multiCheckBoxSpacing: {
        padding: '0 2.4rem 0 0 !important',
    },
    multiCheckBoxOutlineSpacing: {
        '&:nth-child(even) > div': {
            padding: '.6rem 0 .6rem 1.2rem',
            height: '100%',
        },
        '&:nth-child(odd) > div': {
            padding: '.6rem 1.2rem .6rem 0',
            height: '100%',
        },
        [`@media (max-width: ${breakpoints.md})`]: {
            '&:nth-child(even) > div': {
                padding: '.6rem 0',
                height: '100%',
            },
            '&:nth-child(odd) > div': {
                padding: '.6rem 0',
                height: '100%',
            },
        },
    },
    helperText: (helperTextColor?: string) =>
        (({
            color: helperTextColor,
            fontWeight: 400,
            width: '100%',
            fontSize: '1.4rem',

            [`@media (min-width: ${breakpoints.xl})`]: {
                fontSize: '1.6rem',
            },

            [`@media (max-width: ${breakpoints.sm})`]: {
                fontSize: '1.2rem',
            },

            marginBottom: '1rem',
        }) as const),
    logoContainer: {
        marginBottom: '0.8rem',
    },
    loadingSpinner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
    },
} as const;
